import { wpFetch } from 'src/helpers/wpApiHandler';

const useDeleteLead = async (leadId) => {
  const response = await wpFetch(['delete-lead'], {
    method: 'DELETE',
    body: leadId,
  });
  return response;
};

export default useDeleteLead;
